import React, { useState, useRef, useEffect } from "react";
import "./CustomSelect.css"; // You can use Tailwind here if you want

const CustomSelect = ({ options = [], value, onChange, placeholder = "Select option", classes }) => {
    const wrapperRef = useRef(null);
    const inputRef = useRef(null);

    const [active, setActive] = useState(false);
    const [search, setSearch] = useState("");
    const [filteredOptions, setFilteredOptions] = useState(options);

    useEffect(() => {
        setFilteredOptions(
            options.filter((opt) =>
                opt.option?.toLowerCase().startsWith(search.toLowerCase())
            )
        );
    }, [search, options]);

    const handleSelect = (selected) => {
        onChange && onChange(selected.value); // send value to parent
        setSearch(""); // clear search
        setActive(false);
    };

    // Close dropdown if clicked outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setActive(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const displayText =
        options.find((opt) => opt.value === value)?.option || placeholder;

    return (
        <div
            ref={wrapperRef}
            className={`wrapper relative ${active ? "active" : ""} w-[100%] ${classes}`}
        >
            <div
                className="select-btn text-black font-[600]"
                onClick={() => setActive(!active)}
            >
                <span>{displayText}</span>
                <i className="fa-solid fa-angle-down "></i>
            </div>

            <div className="content shadow-1">
                <div className="search">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        ref={inputRef}
                    />
                </div>
                <ul className="options my-scroll-2">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((opt) => (
                            <li
                                key={opt.value}
                                className={opt.value === value ? "selected" : ""}
                                onClick={() => handleSelect(opt)}
                            >
                                {opt.option}
                            </li>
                        ))
                    ) : (
                        <p style={{ marginTop: "10px" }}>Oops! Not found</p>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default CustomSelect;
